import { createSelector } from '@ngrx/store';
import { CompanyParameters, ParameterItem, UserState } from 'app/shared/models';
import { AppState } from 'app/state/app.state';
import { companyIdAndProductContextIdSelect } from './company-context.selectors';

export const selectUserState = (state: AppState) => state.userState;

export const selectCompanyParameters = createSelector(
  selectUserState,
  (state: UserState) => state.companyParameters
);

export const selectCurrentGroupAndCompanyParameter = createSelector(
  selectUserState,
  (state: UserState): [number, ParameterItem] => ([state.currentCompanyId, state.companyParameters[0]?.parameters?.find(param => param.name === 'currentGroup')])
);

export const selectCurrentGroupParameter = createSelector(
  selectCompanyParameters,
  (parameters: CompanyParameters[]): ParameterItem => parameters[0]?.parameters?.find(param => param.name === 'currentGroup')
);

export const selectCurrentGroupParameterValue = createSelector(
  selectCurrentGroupParameter,
  (item: ParameterItem): string => item?.value
);

export const selectCurrentGroup = createSelector(
  selectCurrentGroupAndCompanyParameter,
  companyIdAndProductContextIdSelect,
  (state: AppState) => state.reportState.resolvedCurrentGroup,
  ([companyId, parameter], context, group) => {
    if (
      !parameter?.value ||
      !group ||
      companyId !== context.companyId ||
      group.companyId !== context.companyId ||
      group.productContextId !== context.productContextId ||
      group.id !== Number(parameter.value)
    ) {
      return null;
    }

    return group;
  },
);

export const selectCurrentGroupName = createSelector(
  selectCurrentGroup,
  (group) => group?.name ?? null,
);

export const selectCurrentGroupIsLeafNode = createSelector(
  selectCompanyParameters,
  (parameters: CompanyParameters[]): boolean =>
    parameters[0]?.parameters?.find(param => param.name === 'currentGroupIsLeafNode')?.value === '1'
);

export const selectUserParameters = createSelector(
    selectCompanyParameters,
    (parameters: CompanyParameters[]): ParameterItem[] => parameters[0]?.parameters
  );
